import { useEffect } from "react";
import "../../components/BlogPost.css";

export default function BookRecommendations(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="singlePost">
      <div className="singlePostWrapper">
        <img
          className="singlePostImg"
          src="https://images.unsplash.com/photo-1598301257982-0cf014dabbcd?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
          alt="How to get better book recommendations"
        />
        <h1 className="singlePostTitle">
          How to get better book recommendations
        </h1>
        <p className="singlePostDesc">
          If you’re part of the self-improvement community, you’ve probably had
          the problem of not knowing which book to read next. There are so many
          books on this topic out there that you won’t be able to read them all
          in your lifetime. I also had the problem that books about this topic
          that were recommended by my friends often didn’t match my taste.
          <br />
          <br />
          After many abandoned books and much disappointment, I devised a method
          to get good book recommendations. The realisation I had was that,
          firstly, I would only want to get book recommendations from people I
          looked up to in some way. The second realisation was that it was too
          risky for me to start books that were ‘experimental’, in the sense
          that they haven’t been recommended by several trusted people. I was so
          extreme, because each book has the potential of strongly influencing
          my live and therefore I want to be careful with the selection.
          <br />
          <br />
          This left me with the following problem: I am looking for books that
          are recommended by several persons that I look up to. I then searched
          the internet for websites that recommend books according to these
          values. Without success.
          <br />
          <br />
          I finally came up with the idea that the biggest collection of idols
          is on Youtube. There I can watch the videos of self-improvement
          channels and decide if there book recommendations will have a positive
          impact on me. Unfortunately, it is very difficult to get a common
          opinion of the Youtuber’s I look up to, because they hide their book
          recommendations in videos or on some private pages.
          <br />
          <br />
          My solution was to gather all the book recommendations from my
          favorite Youtuber’s on the internet and write a program where whenever
          I look for a new book, I only need to enter the Youtuber names I
          currently like the most and the program shows me the common book
          recommendations.
          <br />
          <br />
          You can use my program and my youtuber and book list for free on{" "}
          <a href="https://youbooks.net">Youbooks</a>
          <br />
          <br />
          <a href="https://youbooks.net">
            <img
              src="assets/images/youbooks.png"
              alt="youbooks book recommendation tool"
            />
          </a>
          <br />
          Also if you like my content, check out the books that influenced me
          the most in the topics personal finances, fulfillment and
          self-improvement on the Books tab.
        </p>
      </div>
    </div>
  );
}
